import PRODUCT_LIST from '../../types/product-list'

export default {
  [PRODUCT_LIST.GETTERS.GET_PRODUCT_PRICE]: ({products}) => (productId) => {
    return products.find(product => {
      return product.id === Number(productId)
    })
  }
}
